import { AppHeader } from "../components/layout/AppHeader";
import { Hero } from "../components/Homes/Hero";
import { CompareOffers } from "../components/Homes/CompareOffers";
import { Arguments } from "../components/Homes/Arguments";
import { Cta } from "../components/Homes/Cta";
import { Services } from "../components/Homes/Services";
import { LegalLinks } from "../components/layout/LegalLinks";
import { CookieConsent } from "../cookies/CookieConsent";
import { DataInformation } from "../components/Homes/DataInformation";

export const Home = () => {
  return (
    <>
      <div className="">
        <AppHeader />
        <Hero />
        <CompareOffers />
        <Arguments />
        <Cta />
        <Services />
        <DataInformation />
        <LegalLinks />
        <CookieConsent />
      </div>
    </>
  );
};
